import { Alert, Button, Space, Table, Typography } from 'antd'
import { InvoicedLine } from './markUnbillableApi'
import {
  RepricedLineRow,
  hasMatchableLines,
  matchButtonLabel,
  repricedSummary,
  toRepricedRows,
} from './markUnbillableModel'

const { Paragraph, Title } = Typography

const columns = [
  { title: 'Work area', dataIndex: 'workarea', key: 'workarea' },
  { title: 'Kind', dataIndex: 'kind', key: 'kind', width: 70 },
  { title: 'Name', dataIndex: 'name', key: 'name' },
  { title: 'Visit date', dataIndex: 'visitDate', key: 'visitDate', width: 110 },
  { title: 'Invoice', dataIndex: 'invoices', key: 'invoices', width: 140 },
  { title: 'Billed', dataIndex: 'billedAmount', key: 'billedAmount', width: 110, align: 'right' as const },
  { title: 'Current', dataIndex: 'amount', key: 'amount', width: 110, align: 'right' as const },
  { title: 'Difference', dataIndex: 'difference', key: 'difference', width: 110, align: 'right' as const },
]

type Props = {
  lines: InvoicedLine[]
  selectedLineIds: string[]
  loading: boolean
  submitting: boolean
  disabled: boolean
  onSelectionChange: (lineIds: string[]) => void
  onSubmit: () => void
}

const RepricedLinesSection = ({
  lines,
  selectedLineIds,
  loading,
  submitting,
  disabled,
  onSelectionChange,
  onSubmit,
}: Props) => (
  <Space direction="vertical" size={12} style={{ width: '100%' }}>
    <Title level={5} style={{ marginBottom: 0 }}>Price changed after invoicing</Title>
    <Paragraph type="secondary" style={{ marginBottom: 0 }}>
      Invoiced lines whose current price differs from what the invoice charged. Select labor lines and
      match their billed price to set each line&apos;s price to what was billed; hours and payroll stay the
      same. Item lines are read-only.
    </Paragraph>
    <Alert type="info" showIcon message={repricedSummary(lines)} />
    {lines.length > 0 && (
      <Table<RepricedLineRow>
        size="small"
        columns={columns}
        dataSource={toRepricedRows(lines)}
        pagination={false}
        loading={loading}
        scroll={{ x: true }}
        rowSelection={{
          selectedRowKeys: selectedLineIds,
          onChange: keys => onSelectionChange(keys as string[]),
          getCheckboxProps: row => ({ disabled: !row.matchable || submitting || disabled }),
          renderCell: (_checked, row, _index, node) => (row.matchable ? node : null),
        }}
      />
    )}
    {hasMatchableLines(lines) && (
      <Space>
        <Button
          type="primary"
          danger
          onClick={onSubmit}
          loading={submitting}
          disabled={selectedLineIds.length === 0 || disabled}
        >
          {matchButtonLabel(selectedLineIds.length)}
        </Button>
      </Space>
    )}
  </Space>
)

export default RepricedLinesSection
